/**
 * All KPI socket event names — keep in 100% sync with backend REALTIME_EVENTS
 * (src/common/realtime/realtime.service.ts)
 */
export const REALTIME_EVENTS = {
  // Admin Dashboard & Centralized Aggregators
  DASHBOARD_KPI_UPDATED: 'kpi:dashboard:updated',
  DASHBOARD_ADMIN_UPDATED: 'kpi:dashboard:admin',
  DASHBOARD_STUDENT_UPDATED: 'kpi:dashboard:student',
  DASHBOARD_STAFF_UPDATED: 'kpi:dashboard:staff',
  DASHBOARD_ALL_KPIS_UPDATED: 'kpi:dashboard:kpis',

  // Specific Domain KPI Realtime Events
  STUDENT_KPI_UPDATED: 'kpi:student:updated',
  STAFF_KPI_UPDATED: 'kpi:staff:updated',
  SEAT_KPI_UPDATED: 'kpi:seat:updated',
  ACADEMIC_KPI_UPDATED: 'kpi:academic:updated',
  SUBJECT_KPI_UPDATED: 'kpi:subject:updated',
  USER_KPI_UPDATED: 'kpi:user:updated',
  ROLE_KPI_UPDATED: 'kpi:role:updated',
  DEPARTMENT_KPI_UPDATED: 'kpi:department:updated',
  DESIGNATION_KPI_UPDATED: 'kpi:designation:updated',

  // Attendance, Fees, Admissions, etc.
  DASHBOARD_ATTENDANCE_UPDATED: 'kpi:attendance:updated',
  DASHBOARD_FEES_STATUS_UPDATED: 'kpi:fees-status:updated',
  DASHBOARD_APPROVALS_UPDATED: 'kpi:approvals:updated',
  DASHBOARD_ACTIVITY_UPDATED: 'kpi:activity:updated',
  ADMISSIONS_KPI_UPDATED: 'kpi:admissions:updated',
  FINANCE_OVERVIEW_UPDATED: 'kpi:finance:updated',
  ASSIGNMENTS_UPDATED: 'kpi:assignments:updated',
  STUDENT_DASHBOARD_UPDATED: 'kpi:student-dashboard:updated',
  COMMUNICATION_STATS_UPDATED: 'kpi:communication:updated',
} as const

export type RealtimeEvent = (typeof REALTIME_EVENTS)[keyof typeof REALTIME_EVENTS]
